"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bridge = void 0;
const websocket_1 = require("websocket");
const handlers_1 = require("./handlers");
const message_1 = require("./message");
class Bridge {
    constructor() {
        this.connection = null;
        this.session = null;
        this.connectCallbacks = [];
        this.disconnectCallbacks = [];
        this.errorCallbacks = [];
        return this;
    }
    onConnect(callback) {
        this.connectCallbacks.push(callback);
        return this;
    }
    onDisconnect(callback) {
        this.disconnectCallbacks.push(callback);
        return this;
    }
    onError(callback) {
        this.errorCallbacks.push(callback);
        return this;
    }
    connect(url) {
        return new Promise((resolve, reject) => {
            this.connection = new websocket_1.w3cwebsocket(url);
            this.connection.onopen = () => {
                if (this.connection === null) {
                    return;
                }
                this.session = new handlers_1.SessionHandler(this.connection);
                for (const callback of this.connectCallbacks) {
                    callback(this.session);
                }
                resolve(this.session);
            };
            this.connection.onclose = (ev) => {
                const reason = ev.reason ?? "unknown reason";
                const code = ev.code ?? -1;
                if (this.session !== null) {
                    this.session.cleanUp();
                    for (const callback of this.disconnectCallbacks) {
                        callback(code, reason);
                    }
                    this.session = null;
                }
                reject(Error(`${reason} (${code})`));
            };
            this.connection.onmessage = (ev) => {
                const message = message_1.Message.parseMessage(String(ev.data));
                this.session?.handleMessage(message);
            };
            this.connection.onerror = (err) => {
                const message = err.message ?? "unknown error";
                if (this.session !== null) {
                    for (const callback of this.errorCallbacks) {
                        callback(Error(message));
                    }
                }
                reject(Error(message));
            };
        });
    }
}
exports.Bridge = Bridge;
